import { forwardRef } from 'react';
// https://github.com/reactjs/react-tabs
import Breadcrumbs from '@components/Breadcrumbs';
import ProductsCarousel from '@components/Carousel/Products';
import PPMobileImage from './components/PPMobileImage';
import PPMobileMainBlock from './components/PPMobileMainBlock';
import PPMobilePrice from './components/PPMobilePrice';
import { observer } from 'mobx-react';
import type { ProductPageSettings } from './index.type';
import PPTabs from './components/PPTabs';
import { sortlist } from './component';
import ProductsMiniCarousel from '@components/Carousel/ProductsMini';

const MobileProductPage = forwardRef<HTMLDivElement, ProductPageSettings>(
  (
    {
      id,
      canBeBought,
      isFavorite,
      isConsentModalAgreed,
      productInfo,
      breadCrumbsLastItem,
      breadCrumbs,
      isItemInCart,
      amountInCart,
      // isDisabledPopup,
      alsoBought,
      isShowCarouselAlsoBought,
      analogs,
      isAnalogsVertical,
      recommendProducts,
      reviewTotalCount,
      isTablet,
      isMobile,
      activeTab,
      setSort,
      isProductAvailableForRefund,
      productRecipes,
      commentTotalCount,
      isProductHasAttachmentInComments,
      task,
      setActiveTab,
      linkToQuestions,
      _commentsResolver,
      changeSort,
      changeUrlToUpBreadCrumbs,
      scrollToReviews
    },
    ref
  ) => (
    <div className='product-page product-page-mobile'>
      {/* MOBILE BOTTOM FIXED ELEMENT */}

      <PPMobilePrice
        id={id}
        isMenu={!!productInfo.isMenu}
        measure_id={productInfo.measure_id}
        canBeBought={canBeBought}
        breadCrumbsLastItem={breadCrumbsLastItem}
        changeUrlToUpBreadCrumbs={changeUrlToUpBreadCrumbs}
        oldPriceField2={productInfo.priceObj.oldPriceField2}
        specialPriceData={productInfo.priceObj.specialPriceData}
        discounPriceField={productInfo.priceObj.discount}
        priceBlockWeightPrice={productInfo.priceObj.priceBlockWeightPrice}
        price2={productInfo.price2}
        measureItem={productInfo.measureItem}
        weight_of_goods={productInfo.weight_of_goods}
        price={productInfo.price}
        isVesovoi={productInfo.ifWeighting}
        oldPriceField={productInfo.priceObj.oldPriceField}
        available={productInfo.available}
        isProductNotForSale={productInfo.isProductNotForSale}
        isPreorder={productInfo.isPreorder}
        isProductArchieved={productInfo.isProductArchieved}
        supplyDate={productInfo.supplyDate}
        isDigital={productInfo.isDigital}
        amountInCart={amountInCart}
        multiPricePromo={productInfo.multiPricePromo}
        promocodeGiftItems={productInfo.promocodeGiftItems}
      />

      <Breadcrumbs withoutBackBtn noPaddingMobile array={breadCrumbs} />
      {/* IMAGE BLOCK */}
      <PPMobileImage
        id={id}
        is_18plus={!!productInfo.is_18plus}
        isConsentModalAgreed={isConsentModalAgreed}
        task={task}
        // isDisabledPopup={isDisabledPopup}
        isFavorite={isFavorite}
        badges={productInfo.badges}
        isFreeze={productInfo.isFreeze}
        isExpressPickupAval={productInfo.isExpressPickupAval}
        isExpressDeliveryAval={productInfo.isExpressDeliveryAval}
        title={productInfo.title}
        images={
          productInfo?.images?.square
            ?.slice(
              0,
              productInfo?.is_18plus ? 1 : productInfo?.images?.square?.length
            )
            ?.map((src, index) => ({
              type: 'img',
              original: productInfo?.images?.original?.[index] || '',
              src
            })) || []
        }
        videos={
          productInfo?.videoFromText?.map(src => ({ type: 'video', src })) || []
        }
        isProductNotForSale={productInfo.isProductNotForSale}
        isShowBell={productInfo.productDiscountNotification}
        isProductArchieved={productInfo.isProductArchieved}
        isMobile={isMobile}
        isTablet={isTablet}
      />
      {/* INFO BLOCK */}
      <PPMobileMainBlock
        id={id}
        isBarMenu={!!productInfo?.isMenu}
        title={productInfo.title}
        subtitle={productInfo.subtitle}
        productArticle={productInfo?.productArticle}
        isDigital={productInfo.isDigital}
        averageRating={productInfo.averageRating}
        salesNumberInfo={productInfo.salesNumberInfo}
        variants={productInfo?.variants}
        available={productInfo.available}
        ifWeighting={productInfo.ifWeighting}
        isExpressPickupAval={!!productInfo?.isExpressPickupAval}
        deliveryDate={productInfo.deliveryDate}
        isExpressDeliveryAval={!!productInfo?.isExpressDeliveryAval}
        gds_count={productInfo.gds_count}
        isProductNotForSale={productInfo.isProductNotForSale}
        isProductArchieved={productInfo.isProductArchieved}
        isPreorder={productInfo.isPreorder}
        bestBeforeDate={productInfo.bestBeforeDate}
        reviewTotalCount={reviewTotalCount}
        scrollToReviews={scrollToReviews}
        isItemInCart={isItemInCart}
        alsoBought={alsoBought}
        isShowCarouselAlsoBought={isShowCarouselAlsoBought}
        newBadges={productInfo.newBadges}
        availableQuantity={productInfo.availableQuantity}
      />

      {!productInfo?.isMenu &&
        !productInfo.available &&
        analogs?.length > 0 &&
        (isAnalogsVertical ? (
          <ProductsCarousel title='Похожие товары' products={analogs} />
        ) : (
          <ProductsMiniCarousel title='Похожие товары' products={analogs} />
        ))}

      {!productInfo.isProductNotForSale && (
        <PPTabs
          isMobile
          carbs={productInfo.carbs}
          proteins={productInfo.proteins}
          reference_weight={productInfo.reference_weight}
          fats={productInfo.fats}
          isBarMenu={!!productInfo?.isMenu}
          ref={ref}
          id={id}
          how_to_make={productInfo.how_to_make}
          isDigital={productInfo.isDigital}
          activeTab={activeTab}
          sortlist={sortlist}
          setSort={setSort}
          isProductAvailableForRefund={isProductAvailableForRefund}
          productRecipes={productRecipes}
          averageRating={productInfo?.averageRating}
          reviewTotalCount={reviewTotalCount}
          commentTotalCount={commentTotalCount}
          isProductHasAttachmentInComments={isProductHasAttachmentInComments}
          setActiveTab={setActiveTab}
          linkToQuestions={linkToQuestions}
          commentsResolver={_commentsResolver}
          changeSort={changeSort}
          weight_of_goods={productInfo?.weight_of_goods}
          measureItem={productInfo?.measureItem}
          country={productInfo?.country}
          attributes={productInfo?.attributes}
          productPackage={productInfo?.productPackage}
          nutritional_value={productInfo?.nutritional_value}
          energy_value={productInfo?.energy_value}
          ingredients={productInfo?.ingredients}
          storage_conditions={productInfo?.storage_conditions}
          gost={productInfo?.gost}
          documents={productInfo?.documents}
          text={productInfo?.text || ''}
          mostUsefulComment={productInfo?.mostUsefulComment}
          isVesovoi={productInfo?.isVesovoi}
          supplier_id={productInfo?.supplier_id}
          videos={productInfo?.videos}
        />
      )}

      {alsoBought.length > 0 && (
        <ProductsCarousel
          products={alsoBought}
          title={'C этим товаром покупают'}
        />
      )}

      {recommendProducts.length > 0 && (
        <ProductsCarousel
          products={recommendProducts}
          title={'Рекомендуем попробовать'}
        />
      )}
    </div>
  )
);

export default observer(MobileProductPage);
